// src/pages/OrderConfirmation.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./OrderConfirmation.css";

export default function OrderConfirmation() {
  const { orderId } = useParams(); // URL se orderId
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) {
      setLoading(false);
      return;
    }
    let mounted = true;
    (async () => {
      try {
        const ref = doc(db, "orders", orderId);
        const snap = await getDoc(ref);
        if (!mounted) return;
        if (!snap.exists()) {
          setOrder({ notFound: true });
        } else {
          setOrder({ id: snap.id, ...snap.data() });
        }
      } catch (err) {
        console.error("Failed to load order", err);
        setOrder({ error: true });
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [orderId]);

  if (loading) return <div className="oc-wrap"><div className="oc-card">Loading order…</div></div>;
  if (!order) return <div className="oc-wrap"><div className="oc-card">No order info available.</div></div>;
  if (order.notFound) return <div className="oc-wrap"><div className="oc-card">Order not found.</div></div>;

  const status = order.status || "initiated";
  const tracking = order.trackingId || "Not available";
  const placedAt =
    order.createdAt && order.createdAt.toDate
      ? order.createdAt.toDate().toLocaleString()
      : "";

  return (
    <div className="oc-wrap">
      <div className="oc-card">
        <div className="oc-emoji">🎉</div>
        <h1>Order Placed Successfully!</h1>

        <div className="oc-row">
          <div className="oc-label">Order ID</div>
          <div className="oc-value">{order.id}</div>
        </div>

        <div className="oc-row">
          <div className="oc-label">Status</div>
          <div className="oc-value">
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </div>
        </div>

        <div className="oc-row">
          <div className="oc-label">Tracking ID</div>
          <div className="oc-value tracking">{tracking}</div>
        </div>

        {placedAt && (
          <div className="oc-row">
            <div className="oc-label">Placed At</div>
            <div className="oc-value">{placedAt}</div>
          </div>
        )}

        <div className="oc-divider" />

        <div className="oc-sub">
          We will ship your order soon. You can track the status using the Tracking ID above.
        </div>

        <div className="oc-actions">
          <Link to="/orders" className="btn">View Orders</Link>
          <Link to="/" className="btn outline">Continue Shopping</Link>
        </div>
      </div>
    </div>
  );
}
